import { motion } from "framer-motion";
import { ProtocolConvergence } from "@/components/triarch/ProtocolConvergence";

export const About = () => (
  <section
    id="protocol"
    data-testid="about-section"
    className="relative py-16 sm:py-24"
  >
    {/* 02 — label + large golden PROTOCOL heading */}
    <div className="mx-auto max-w-5xl px-5 text-center sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mb-7 flex items-center justify-center gap-3 sm:mb-8"
      >
        <span className="h-px w-8 bg-white/15 sm:w-12" />
        <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/45">
          02
        </span>
        <span className="h-px w-8 bg-white/15 sm:w-12" />
      </motion.div>
      <motion.h2
        data-testid="protocol-headline"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="bg-gradient-to-r from-[#b89b5e] via-[#d1b777] to-[#8f7540] bg-clip-text font-display text-4xl font-semibold uppercase tracking-[0.14em] text-transparent drop-shadow-[0_0_24px_rgba(184,155,94,0.18)] sm:text-6xl"
      >
        Protocol
      </motion.h2>
    </div>

    {/* convergence animation — central visual object */}
    <div className="mx-auto mt-10 max-w-5xl px-5 sm:mt-14 sm:px-8">
      <ProtocolConvergence />
    </div>

    {/* doctrine statement — explanation beneath the animation */}
    <div className="mx-auto mt-10 max-w-5xl px-5 text-center sm:mt-14 sm:px-8">
      <motion.p
        data-testid="about-copy"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-90px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        style={{ textWrap: "balance" }}
        className="mx-auto max-w-[920px] font-display text-[1.4rem] font-light leading-[1.32] tracking-[-0.012em] text-white/90 text-glow sm:text-[1.65rem] sm:leading-[1.3] lg:text-[1.95rem] lg:leading-[1.3]"
      >
        <span className="bg-gradient-to-r from-[#b89b5e] via-[#d1b777] to-[#8f7540] bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(184,155,94,0.12)]">
          Triarch operates within the concealed architecture of orchestration —
        </span>{" "}
        <span className="text-white/45">
          where fractured signals are captured before coherence, compressed
          before interpretation, and routed through recursive machine pathways
          until advantage forms beneath the threshold of public recognition.
        </span>
      </motion.p>
    </div>
  </section>
);
